import { ScopeableType } from '../../../types';

export interface ScopeItem {
  scopeableType: ScopeableType;
  scopeableId: number | null;
}

export const SCOPE_TYPE_LABELS: Record<ScopeableType, string> = {
  [ScopeableType.Global]: 'Everything',
  [ScopeableType.Package]: 'Package',
  [ScopeableType.ProductOffering]: 'Product offering',
  [ScopeableType.Program]: 'Program',
};

export const SCOPE_TYPE_RADIO_ORDER: ScopeableType[] = [
  ScopeableType.Global,
  ScopeableType.Package,
  ScopeableType.ProductOffering,
  ScopeableType.Program,
];

export const SCOPE_SELECTOR_RADIO_GROUP_TEST_ID = 'scope-selector-radio-group';
export const SCOPE_SELECTOR_GLOBAL_HINT_TEST_ID = 'scope-selector-global-hint';
export const PRODUCT_OFFERING_MULTI_SELECT_TEST_ID =
  'product-offering-multi-select';
export const PRODUCT_OFFERING_MULTI_SELECT_INPUT_TEST_ID =
  'product-offering-multi-select-input';
export const PROGRAM_SCOPE_SELECT_TEST_ID = 'program-scope-select';
export const SCOPE_SELECTOR_ERROR_TEST_ID = 'scope-selector-error';

export interface ProgramScopeOption {
  id: number;
  name: string;
}

export const SCOPE_PROGRAM_OPTIONS: ProgramScopeOption[] = [
  { id: 1, name: 'Chronic' },
  { id: 2, name: 'Acute' },
];
